import './styles/component-trace.scss'

import React      from 'react'
import PropTypes  from 'prop-types'

import LogComponent from './LogComponent'

const HOLD        = 'HOLD'
const AD_HOC_HOLD = { component: HOLD, hold: true }

const HOLD_COMBINATIONS = {
  // SFTP_DELIVERY:    'DELIVERY_MANAGER',
  DELIVERY_MANAGER: 'DELIVERY_MANAGER'
}

function isAdHocHold(log) {
  return log && log.component === HOLD
}

function hasHold ({ logs, index, firstComponentName, secondComponentName }) {
  return logs[index].component === firstComponentName
    && index < (logs.length - 1)
    && logs[index + 1].component === secondComponentName
}

function hasHolds({ logs, index }) {
  return Object
    .keys(HOLD_COMBINATIONS)
    .find((component) => hasHold({ logs, index, firstComponentName: component, secondComponentName: HOLD_COMBINATIONS[component] }))
}

function processAdHocHolds({ logs, job }) {
  const result = logs.reduce((acc, log, index) => {
    acc.push(log)

    if (hasHolds({ logs, index })) {
      acc.push(AD_HOC_HOLD)
    }

    return acc
  }, [])

  if (job.status === 'ON_HOLD') {
    result.push({ ...AD_HOC_HOLD, active: true })
  }

  return result
}

export default class ComponentTrace extends React.Component {
  static propTypes = {
    job:           PropTypes.object.isRequired,
    logs:          PropTypes.array.isRequired,
    selectedLog:   PropTypes.object,
    onLogSelected: PropTypes.func.isRequired,
  }

  handleLogSelected = (log) => {
    if (!log.hold) {
      this.props.onLogSelected(log)
    }
  }

  render() {
    const { job, logs, selectedLog } = this.props    

    const processedLogs = processAdHocHolds({ logs, job })

    return (
      <div className="component-trace">
        <div className="tip">Click indivitual component to filter full job log by that component. Click again to see full log</div>
        <div className="log-trace-content">
          { processedLogs.map((log, index) => {
            const onLogSelected = () => this.handleLogSelected(log)

            const selected = selectedLog === log
            const dimmed   = !!(selectedLog && !selected)

            return (
              <div key={index} onClick={onLogSelected}>
                <LogComponent
                  hold={!!log.hold}
                  activeHold={!!(isAdHocHold(log) && log.active)}
                  log={log}
                  dimmed={dimmed}
                  selected={selected}
                  hasNext={ index < (processedLogs.length - 1) }
                />
              </div>
            )
          }) }
        </div>
      </div>
    )
  }
}